<div class="panel">
  <div><i class="fa fa-check-circle"></i></div>
  <div><span>บันทึกข้อมูลเรียบร้อย</span></div>
</div>
